(function () {
  var BOUND = "data-v3-contact-modals-bound";
  var OPEN_CLASS = "is-open";
  var NOTE_LINK_SEL = ".product-v3__variant-note-text a";
  var TIP_SEL = "[data-v3-contact-tip]";
  var TIP_CLOSE_SEL = "[data-v3-contact-tip-close]";
  var PIFY_SEL = "[data-v3-contact-pify]";
  var PIFY_OPEN_SEL = "[data-v3-contact-open-pify]";
  var PIFY_CLOSE_SEL = "[data-v3-contact-close-pify]";
  var globalBound = false;

  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function applyPifyScroll(modal) {
    if (!modal) return;
    modal.querySelectorAll("iframe").forEach(function (iframe) {
      if (isMobile()) {
        iframe.style.overflow = "auto";
        iframe.removeAttribute("scrolling");
        return;
      }
      iframe.style.overflow = "hidden";
      iframe.setAttribute("scrolling", "no");
    });
  }

  function openEl(el, lockBody) {
    if (!el) return;
    el.classList.add(OPEN_CLASS);
    el.setAttribute("aria-hidden", "false");
    if (lockBody) document.body.style.overflow = "hidden";
  }

  function closeEl(el, unlockBody) {
    if (!el) return;
    el.classList.remove(OPEN_CLASS);
    el.setAttribute("aria-hidden", "true");
    if (unlockBody) document.body.style.overflow = "";
  }

  function getOpenPify() {
    return document.querySelector(PIFY_SEL + "." + OPEN_CLASS);
  }

  function bindGlobalOnce() {
    if (globalBound) return;
    globalBound = true;

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      var pify = getOpenPify();
      if (pify) closeEl(pify, true);
    });

    window.addEventListener("message", function (event) {
      if (!event || typeof event.data !== "string" || isMobile()) return;
      var payload;
      try {
        payload = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (!payload || payload.height == null) return;
      var height = Number(payload.height);
      if (!height) return;
      document.querySelectorAll(PIFY_SEL + " .product-v3-contact-pify__iframe").forEach(function (iframe) {
        iframe.style.height = height + "px";
        iframe.style.minHeight = height + "px";
      });
    });
  }

  function isNavigableHref(link) {
    var href = (link.getAttribute("href") || "").trim();
    if (!href || href === "#") return false;
    if (href.indexOf("javascript:") === 0) return false;
    return true;
  }

  function bindRoot(root) {
    if (!root || root.getAttribute(BOUND) === "1") return;
    root.setAttribute(BOUND, "1");
    bindGlobalOnce();

    var tip = root.querySelector(TIP_SEL) || document.querySelector(TIP_SEL);
    var pify = root.querySelector(PIFY_SEL) || document.querySelector(PIFY_SEL);

    root.querySelectorAll(NOTE_LINK_SEL).forEach(function (link) {
      link.addEventListener("click", function (event) {
        // 不 stopPropagation，让 GTM document 点击监听仍能收到
        if (link.closest(".product-v3__option-note")) {
          event.preventDefault();
          // 之前打开联系面板的逻辑先注释
          // openEl(tip, false);
          // var panel = tip && tip.querySelector(".product-v3-contact-tip__panel");
          // if (panel) panel.focus();
          window.MiraChatHost?.open();
          return;
        }
        var note = link.closest(".product-v3__variant-note");
        var action = note ? note.getAttribute("data-note-action") : "dialog";
        if (action === "link") {
          if (!isNavigableHref(link)) event.preventDefault();
          return;
        }
        event.preventDefault();
        if (action === "messenger") {
          window.MiraChatHost?.open();
          return;
        }
        openEl(tip, false);
        var panel = tip && tip.querySelector(".product-v3-contact-tip__panel");
        if (panel) panel.focus();
      });
    });

    if (tip) {
      tip.querySelectorAll(TIP_CLOSE_SEL).forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeEl(tip, false);
        });
      });

      tip.querySelectorAll(PIFY_OPEN_SEL).forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          openEl(pify, true);
          applyPifyScroll(pify);
          var dialog = pify && pify.querySelector(".product-v3-contact-pify__dialog");
          if (dialog) dialog.focus();
        });
      });
    }

    if (pify) {
      pify.querySelectorAll(PIFY_CLOSE_SEL).forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeEl(pify, true);
        });
      });

      pify.addEventListener("click", function (event) {
        if (event.target === pify) closeEl(pify, true);
      });
    }
  }

  function init() {
    document.querySelectorAll("[data-product-v3]").forEach(bindRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-product-v3]");
    if (!root) return;
    root.removeAttribute(BOUND);
    bindRoot(root);
  });
})();
